import { render, staticRenderFns } from "./EditServer.vue?vue&type=template&id=8abc9552&scoped=true&"
import script from "./EditServer.vue?vue&type=script&lang=js&"
export * from "./EditServer.vue?vue&type=script&lang=js&"
import style0 from "./EditServer.vue?vue&type=style&index=0&id=8abc9552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abc9552",
  null
  
)

export default component.exports